import { SelectableProduct } from 'types/selectable-product';

export const MAX_SELECTED_PRODUCTS_DEFAULT = 4;

export function getSelectedProductIds(selectedProducts: SelectableProduct[]): string[] {
  return selectedProducts.map((product) => product.id);
}

function catalogById(catalog: SelectableProduct[]): Record<string, SelectableProduct> {
  return Object.fromEntries(catalog.map((product) => [product.id, product]));
}

export function pruneSelectedProducts(
  selectedProducts: SelectableProduct[],
  catalog: SelectableProduct[],
): SelectableProduct[] {
  const productsById = catalogById(catalog);
  return selectedProducts
    .map((product) => productsById[product.id])
    .filter((product): product is SelectableProduct => product !== undefined);
}

export function resolveInitialSelectedProducts(
  selectedProducts: SelectableProduct[],
  catalog: SelectableProduct[],
  shouldPreselectWhenEmpty: boolean,
): SelectableProduct[] | undefined {
  if (catalog.length === 0) {
    return undefined;
  }

  const prunedProducts = pruneSelectedProducts(selectedProducts, catalog);

  if (prunedProducts.length !== selectedProducts.length) {
    return prunedProducts.length > 0 ? prunedProducts : [catalog[0]];
  }

  if (shouldPreselectWhenEmpty && selectedProducts.length === 0) {
    return [catalog[0]];
  }

  return undefined;
}

export function isSelectableProduct(value: unknown): value is SelectableProduct {
  return (
    typeof value === 'object' &&
    value !== null &&
    'id' in value &&
    'name' in value &&
    'imageUrl' in value &&
    'mockupImageUrl' in value
  );
}

export function normalizeSelectedProducts(stored: unknown): SelectableProduct[] {
  if (!Array.isArray(stored) || stored.length === 0) {
    return [];
  }

  return stored.every(isSelectableProduct) ? stored : [];
}
